export function axAsType(x) {
    return this.axIsType(x) ? x : null;
}
